import { useEffect, useState } from "react";
import { Popconfirm, Input, Select, Flex, Spin, App } from "antd";
import CustomButton from "../../components/CustomButton/Button";
import CustomTable from "../../components/CustomTable/CustomTable";
import PrimaryButton from "../../components/CustomButton/PrimaryButton";
import { masterData, addMasterData, updateMasterDataStatus } from "../../redux/slices/MasterDataSlice";
import { useDispatch, useSelector } from "react-redux";

const MasterData = () => {
    const { data, loading, error } = useSelector((state) => state.masterData);
    const { message, notification } = App.useApp();
    const dispatch = useDispatch();
    const [type, setType] = useState("industry");
    const [name, setName] = useState("");
    const [searchText, setSearchText] = useState("");

    const dropdownTypes = [
        { value: "industry", label: "Industry Type" },
        { value: "annual_turnover", label: "Annual Turnover" },
        { value: "designation", label: "Designation" },
        { value: "platform_fee", label: "Platform Fee" },
        { value: "rating", label: "Ratings" },
    ];

    const addValue = () => {
        if (!name.trim()) {
            return message.warning("Enter value cannot be empty");
        }

        let finalName = name;

        // Convert platform_fee to decimal
        if (type === "platform_fee") {
            let clean = name.replace("%", "");       // remove %
            let num = parseFloat(clean);

            if (isNaN(num)) {
                return message.warning("Enter valid platform fee number");
            }

            finalName = (num / 100).toString();      // convert to decimal
        }

        dispatch(addMasterData({ type, name: finalName }))
            .unwrap()
            .then(() => {
                message.success("Value added successfully!");
                setName("");

                dispatch(masterData(type));
            })
            .catch((err) => {
                message.error(`Failed to change status: ${err}`);
            });
    };



    const updateStatus = (id, action) => {
        dispatch(updateMasterDataStatus({ id, type, action }))
            .unwrap()
            .then(() => {
                message.success("Status changed successfully!");
                dispatch(masterData(type));
            })
            .catch((err) => {
                message.error(`Failed to change status: ${err}`);
            });
    };

    useEffect(() => {
        dispatch(masterData(type));
    }, [dispatch, type]);

    useEffect(() => {
        if (error) {
            notification.error({
                message: "Request Failed",
                description: error,
                placement: "topRight",
            });
        }
    }, [error, notification]);


    const keyMap = {
        industry: "industryTypeName",
        annual_turnover: "annualTurnoverName",
        designation: "designationName",
        platform_fee: "platformFee",
        rating: "ratingDesc",
    };

    const keyMapId = {
        industry: "industryTypeId",
        annual_turnover: "annualTurnoverId",
        designation: "designationId",
        platform_fee: "platformFeeId",
        rating: "ratingId",
    };

    const filteredList = data?.filter((item) => {
        const key = keyMap[type];
        return key && item[key]?.toLowerCase().includes(searchText.toLowerCase());
    });

    const columns = [
        {
            title: "Value",
            key: "name",
            render: (_, record) => {
                const value = record[keyMap[type]];

                if (!value) return "-";

                if (type === "platform_fee") {
                    let num = parseFloat(value);

                    if (isNaN(num)) return value;

                    if (value.includes("%")) return value;

                    return `${(num * 100).toFixed(2)}%`;
                }

                return value;
            }
        },
        {
            title: "Action",
            render: (record) => {
                const isInactive = record.isActive === false;

                return (
                    <div style={{ display: "flex", gap: 10 }}>
                        {/* DELETE button only for active rows */}

                        <Popconfirm
                            title="Do you want change the status?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => updateStatus(record[keyMapId[type]], !isInactive ? "deactivate" : "activate")}
                        >
                            <CustomButton variant="outlined" color={!isInactive ? "danger" : "primary"}>
                                {!isInactive ? "Inactivate" : "Activate"}
                            </CustomButton>
                        </Popconfirm>


                    </div>
                );
            }
        }


    ];

    return (
        <>
            <Spin spinning={loading} tip="Loading Data...">
                <div >
                {/* style={{ padding: 24 }} */}
                    <h2>Master Dropdown Manager</h2>

                    <Flex style={{ marginBottom: 15 }} justify="space-between" align="center">

                        <Flex gap={10} align="center">

                            <Select
                                style={{ width: 300, height: 46.6 }}
                                value={type}
                                showSearch
                                onChange={(v) => {
                                    setType(v);
                                    setName("");
                                }}
                                options={dropdownTypes}
                            />

                            <Input
                                placeholder="Enter value"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />

                            <PrimaryButton onClick={addValue}>
                                Add
                            </PrimaryButton>

                        </Flex>

                        <Input
                            placeholder="Search values"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ width: 300, marginBottom: 15, marginTop: 15 }}
                            allowClear
                        />

                    </Flex>

                    <CustomTable
                        dataSource={filteredList}
                        columns={columns}
                        rowKey="id"
                        bordered
                    />

                </div>
            </Spin>
        </>
    );
};

export default MasterData;
